import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BookingContext } from '../../context/BookingContext';
import { AuthContext } from '../../context/AuthContext';
import './Confirmation.css';

const Confirmation = () => {
  const { bookingData, resetBookingData } = useContext(BookingContext);
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  // Vérifier que toutes les étapes précédentes sont complétées
  useEffect(() => {
    if (!bookingData.practitioner || !bookingData.service || !bookingData.date ||
      !bookingData.time || !bookingData.name || !bookingData.email) {
      // Redirection si les informations nécessaires ne sont pas présentes
      navigate('/booking', { replace: true });
    }
  }, [bookingData, navigate]);

  const handleNewAppointment = () => {
    resetBookingData();
    navigate('/booking');
  };

  // Formatage de la durée pour l'affichage
  const formatDuration = (duration) => {
    if (duration === 90) return '1h30';
    if (duration === 60) return '1h';
    if (duration === 45) return '45min';
    return `${duration} min`;
  };

  return (
    <div className="confirmation-container">
      <div className="confirmation-icon">✓</div>
      <h2>Rendez-vous confirmé !</h2>
      <p>Vous recevrez prochainement un email de confirmation à l'adresse indiquée.</p>

      <div className="appointment-details">
        <div className="detail-row">
          <div className="detail-label">Praticien :</div>
          <div className="detail-value">{bookingData.practitioner?.name}</div>
        </div>
        <div className="detail-row">
          <div className="detail-label">Service :</div>
          <div className="detail-value">{bookingData.serviceTitle}</div>
        </div>
        <div className="detail-row">
          <div className="detail-label">Date :</div>
          <div className="detail-value">{bookingData.formattedDate}</div>
        </div>
        <div className="detail-row">
          <div className="detail-label">Heure :</div>
          <div className="detail-value">{bookingData.time}</div>
        </div>
        <div className="detail-row">
          <div className="detail-label">Durée :</div>
          <div className="detail-value">{formatDuration(bookingData.duration)}</div>
        </div>
        <div className="detail-row">
          <div className="detail-label">Prix :</div>
          <div className="detail-value">{bookingData.price}€</div>
        </div>
        <div className="detail-row">
          <div className="detail-label">Type :</div>
          <div className="detail-value">
            {bookingData.isRemote ? (
              <span className="remote-badge">À distance (téléconsultation)</span>
            ) : (
              <span className="in-person-badge">En présentiel</span>
            )}
          </div>
        </div>
      </div>

      {/* Afficher les notes de service si elles existent */}
      {bookingData.notes && (
        <div className="detail-row" style={{ display: 'block', marginTop: '15px' }}>
          <div className="detail-label" style={{ marginBottom: '5px' }}>Informations complémentaires :</div>
          <div className="detail-value" style={{
            whiteSpace: 'pre-line',
            backgroundColor: '#f0f7f3',
            padding: '10px',
            borderRadius: '5px',
            borderLeft: '3px solid #3a865f'
          }}>
            {bookingData.notes}
          </div>
        </div>
      )}

      {/* Afficher des informations spécifiques pour les rendez-vous à distance */}
      {bookingData.isRemote && (
        <div className="remote-info-box">
          <h3>Informations sur votre consultation à distance</h3>
          {bookingData.remoteDetails?.meetLink ? (
            <>
              <p><strong>Votre lien Google Meet :</strong></p>
              <div className="meet-link-container">
                <a
                  href={bookingData.remoteDetails.meetLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="meet-link"
                >
                  {bookingData.remoteDetails.meetLink}
                </a>
                <button
                  className="btn-copy-link"
                  onClick={() => {
                    navigator.clipboard.writeText(bookingData.remoteDetails.meetLink)
                      .then(() => alert("Lien copié !"));
                  }}
                  title="Copier le lien"
                >
                  <i className="fas fa-copy"></i>
                </button>
              </div>
              <p className="meet-instructions">
                Cliquez sur ce lien à l'heure de votre rendez-vous pour rejoindre la visioconférence Google Meet.
              </p>
            </>
          ) : (
            <p>Un lien Google Meet pour rejoindre votre consultation à distance vous sera envoyé par email avant le rendez-vous.</p>
          )}
          <p>Assurez-vous d'avoir une connexion internet stable et un environnement calme pour votre consultation.</p>
        </div>
      )}

      <div className="confirmation-actions">
        <button className="btn" onClick={handleNewAppointment}>
          Prendre un nouveau rendez-vous
        </button>

        {currentUser && (
          <Link to="/dashboard" className="btn btn-secondary">
            Voir mes rendez-vous
          </Link>
        )}
      </div>
    </div>
  );
};

export default Confirmation;